// IE Hub - Help & Support Service
// Provides API operations for Help & Support page (summary + external link logs)

import { httpGet, httpPost } from "../http";
import { supportEndpoints } from "../endpoints";
import { femaCapture } from "../../fema/capture";
import type { ApiResponse, RequestConfig } from "../types";

export interface ExternalLinkLogRequest {
  linkName: string;
  linkAddress: string;
  customerId?: string | number;
  userId?: string | number;
}

export class HelpSupportService {
  static async getFilledSectionSummary(
    customerId: string | number,
    config?: RequestConfig
  ): Promise<ApiResponse<any>> {
    try {
      const response = await httpGet<ApiResponse<any>>(
        supportEndpoints.getFilledSectionSummaryV(customerId),
        config
      );
      return response.data;
    } catch (error: any) {
      if (!config?.skipErrorCapture) {
        femaCapture("help_support_summary_error", error, {
          category: "api",
          severity: "warning",
          context: { customerId },
          skipSanitization: false,
          user: {},
        });
      }
      throw error;
    }
  }

  static async logExternalLink(
    payload: ExternalLinkLogRequest,
    config?: RequestConfig
  ): Promise<ApiResponse<any>> {
    try {
      const response = await httpPost<ApiResponse<any>>(
        supportEndpoints.logExternalLink(),
        payload,
        config
      );
      return response.data;
    } catch (error: any) {
      // Non-blocking logging; capture but don't throw
      if (!config?.skipErrorCapture) {
        femaCapture("help_support_external_link_log_error", error, {
          category: "api",
          severity: "warning",
          context: { linkName: payload?.linkName },
          skipSanitization: false,
          user: {},
        });
      }
      return {
        success: true,
        message: "logging_failed_non_blocking",
        timestamp: new Date().toISOString(),
      } as ApiResponse<any>;
    }
  }
}

export default HelpSupportService;



